export const fabricTop100Meta: Record<
  string,
  { displayName: string; category: string; armType: string; bicepType: string }
> = {
  // ─── Capacity & Workspace ────────────────────────────────────────
  fabric_capacity: {
    displayName: "Fabric Capacity",
    category: "core",
    armType: "Microsoft.Fabric/capacities",
    bicepType: "Microsoft.Fabric/capacities",
  },
  fabric_workspace: {
    displayName: "Fabric Workspace",
    category: "core",
    armType: "Microsoft.Fabric/workspaces",
    bicepType: "Microsoft.Fabric/workspaces",
  },
  fabric_folder: {
    displayName: "Fabric Folder",
    category: "core",
    armType: "Microsoft.Fabric/workspaces/folders",
    bicepType: "Microsoft.Fabric/workspaces/folders",
  },
  fabric_deployment_pipeline: {
    displayName: "Deployment Pipeline",
    category: "core",
    armType: "Microsoft.Fabric/deploymentPipelines",
    bicepType: "Microsoft.Fabric/deploymentPipelines",
  },

  // ─── Data & Storage ──────────────────────────────────────────────
  fabric_lakehouse: {
    displayName: "Fabric Lakehouse",
    category: "data",
    armType: "Microsoft.Fabric/workspaces/lakehouses",
    bicepType: "Microsoft.Fabric/workspaces/lakehouses",
  },
  fabric_warehouse: {
    displayName: "Fabric Warehouse",
    category: "data",
    armType: "Microsoft.Fabric/workspaces/warehouses",
    bicepType: "Microsoft.Fabric/workspaces/warehouses",
  },
  fabric_sql_database: {
    displayName: "SQL Database",
    category: "data",
    armType: "Microsoft.Fabric/workspaces/sqlDatabases",
    bicepType: "Microsoft.Fabric/workspaces/sqlDatabases",
  },
  fabric_onelake: {
    displayName: "OneLake",
    category: "data",
    armType: "Microsoft.Fabric/oneLake",
    bicepType: "Microsoft.Fabric/oneLake",
  },

  // ─── Engineering ─────────────────────────────────────────────────
  fabric_pipeline: {
    displayName: "Data Pipeline",
    category: "engineering",
    armType: "Microsoft.Fabric/workspaces/dataPipelines",
    bicepType: "Microsoft.Fabric/workspaces/dataPipelines",
  },
  fabric_dataflow: {
    displayName: "Dataflow Gen2",
    category: "engineering",
    armType: "Microsoft.Fabric/workspaces/dataflows",
    bicepType: "Microsoft.Fabric/workspaces/dataflows",
  },
  fabric_notebook: {
    displayName: "Spark Notebook",
    category: "engineering",
    armType: "Microsoft.Fabric/workspaces/notebooks",
    bicepType: "Microsoft.Fabric/workspaces/notebooks",
  },

  // ─── Analytics & AI ─────────────────────────────────────────────
  fabric_semantic_model: {
    displayName: "Semantic Model",
    category: "analytics",
    armType: "Microsoft.Fabric/workspaces/semanticModels",
    bicepType: "Microsoft.Fabric/workspaces/semanticModels",
  },
  fabric_report: {
    displayName: "Power BI Report",
    category: "analytics",
    armType: "Microsoft.Fabric/workspaces/reports",
    bicepType: "Microsoft.Fabric/workspaces/reports",
  },
  fabric_ml_model: {
    displayName: "ML Model",
    category: "analytics",
    armType: "Microsoft.Fabric/workspaces/mlModels",
    bicepType: "Microsoft.Fabric/workspaces/mlModels",
  },
  fabric_data_agent: {
    displayName: "Data Agent",
    category: "analytics",
    armType: "Microsoft.Fabric/workspaces/dataAgents",
    bicepType: "Microsoft.Fabric/workspaces/dataAgents",
  },

  // ─── Real-time Intelligence ──────────────────────────────────────
  fabric_eventstream: {
    displayName: "Eventstream",
    category: "realtime",
    armType: "Microsoft.Fabric/workspaces/eventstreams",
    bicepType: "Microsoft.Fabric/workspaces/eventstreams",
  },
  fabric_eventhouse: {
    displayName: "Eventhouse",
    category: "realtime",
    armType: "Microsoft.Fabric/workspaces/eventhouses",
    bicepType: "Microsoft.Fabric/workspaces/eventhouses",
  },
  fabric_kql_database: {
    displayName: "KQL Database",
    category: "realtime",
    armType: "Microsoft.Fabric/workspaces/kqlDatabases",
    bicepType: "Microsoft.Fabric/workspaces/kqlDatabases",
  },

  // ─── Gouvernance ─────────────────────────────────────────────────
  azurerm_purview_account: {
    displayName: "Microsoft Purview",
    category: "governance",
    armType: "Microsoft.Purview/accounts",
    bicepType: "Microsoft.Purview/accounts",
  },
  azurerm_policy_assignment: {
    displayName: "Compliance Policy",
    category: "governance",
    armType: "Microsoft.Authorization/policyAssignments",
    bicepType: "Microsoft.Authorization/policyAssignments",
  },
  fabric_domain: {
    displayName: "Fabric Domain",
    category: "governance",
    armType: "Microsoft.Fabric/domains",
    bicepType: "Microsoft.Fabric/domains",
  },
};
